import rose from '../Palettes/rose';

const colors = {
  primary: rose[600],
  primaryDark: rose[700],
  primaryLight: rose[400],
  primaryContrastText: '#fff',
  secondary: rose[600],
  secondaryLight: rose[400],
  primaryText: rose[700],
  blackHigh: 'rgba(0, 0, 0, 0.87)',
  blackMedium: 'rgba(0, 0, 0, 0.6)',
  blackInactive: 'rgba(0, 0, 0, 0.54)',
  blackDisabled: 'rgba(0, 0, 0, 0.38)',
  black: '#000',
  blackGradient: '#333',
  greyDark: '#58595b',
  greyLight: '#dbdbdb',
  whiteLight: 'rgba(255, 255, 255, 0.7)',
  white: '#fff',
  blue: '#1976d2',
  blueDark: '#0288d1',
  success: '#679937',
  warning: '#ed6c02',
  error: '#d32f2f',
  info: '#0288d1',
  grey: '#9e9e9e',
  actionHover: 'rgba(0, 0, 0, 0.04)',
  actionSelected: 'rgba(0, 0, 0, 0.08)',
  textSecondary: 'rgba(0, 0, 0, 0.6)',
};

export default colors;
